import type { App } from 'vue'
import {
  TableCell as AppTableCell,
  TableHead as AppTableHead,
  TableRow as AppTableRow,
} from '@/components/ui/table'
import AppTable from './app-table.vue'

export const useTable = {
  install (app: App) {
    app.component('AppTable', AppTable)
    app.component('AppTableCell', AppTableCell)
    app.component('AppTableRow', AppTableRow)
    app.component('AppTableHead', AppTableHead)
  },
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    AppTable: typeof AppTable,
    AppTableCell: typeof AppTableCell,
    AppTableRow: typeof AppTableRow,
    AppTableHead: typeof AppTableHead,
  }
}
